/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rating_Somewhat_DissatisfiedInputs */

const sv_rating_somewhat_dissatisfied = /** @type {(inputs: Rating_Somewhat_DissatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganska missnöjd`)
};

const en_rating_somewhat_dissatisfied = /** @type {(inputs: Rating_Somewhat_DissatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somewhat dissatisfied`)
};

/**
* | output |
* | --- |
* | "Somewhat dissatisfied" |
*
* @param {Rating_Somewhat_DissatisfiedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const rating_somewhat_dissatisfied = /** @type {((inputs?: Rating_Somewhat_DissatisfiedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_Somewhat_DissatisfiedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_rating_somewhat_dissatisfied(inputs)
	return en_rating_somewhat_dissatisfied(inputs)
});